export type ToastType = 'success' | 'error' | 'info' | 'warning';

/**
 * The angular2-toaster options this app uses, with the same defaults.
 */
export class ToasterConfig {
  positionClass: string;
  mouseoverTimerStop: boolean;
  animation: string;
  limit: number | null;
  timeout: number | Partial<Record<ToastType, number>>;

  constructor(configOverrides: Partial<ToasterConfig> = {}) {
    this.positionClass = configOverrides.positionClass || 'toast-top-right';
    this.mouseoverTimerStop = configOverrides.mouseoverTimerStop ?? false;
    this.animation = configOverrides.animation || '';
    this.limit = configOverrides.limit || null;
    this.timeout = configOverrides.timeout ?? 5000;
  }
}
